/**
 * 票链云 — API 契约
 *
 * 前后端共用这些类型，前端不再手写一遍接口形状。
 * 统一响应包 / 统一分页 / 统一错误码是这里的核心约定。
 */
/* ==========================================================================
 * 统一响应包
 * ========================================================================== */
/** 业务错误码 —— 与 HTTP 状态码配合使用，前端主要看这个 */
export const ApiCode = {
    OK: 0,
    /** 参数校验失败 */
    INVALID_PARAM: 40001,
    /** 未登录或凭证失效 */
    UNAUTHORIZED: 40100,
    /** 无功能权限 */
    FORBIDDEN: 40300,
    /** 数据权限不足（能看到菜单但看不到这条数据） */
    DATA_FORBIDDEN: 40301,
    /** 资源不存在 */
    NOT_FOUND: 40400,
    /** 状态冲突，如对已归档的发票再次审批 */
    CONFLICT: 40900,
    /** 触发业务规则拦截，如红冲票直接推送 T+ */
    BUSINESS_RULE_VIOLATION: 42200,
    /** 接口配额耗尽 */
    QUOTA_EXCEEDED: 42900,
    /** 外部接口不可用（业务可降级处理） */
    PROVIDER_UNAVAILABLE: 50300,
    INTERNAL_ERROR: 50000,
};
//# sourceMappingURL=api.js.map